import React from "react";
import "./index.css";
import { translate } from "../../common/localization"
interface props {
  currentPage: number;
  numberOfPages: number;
  completed: boolean;
}

const pageControl = ({ currentPage, numberOfPages, completed }: props) => {
  const getCurrentBarPercentage = () => {
    if (completed) return "100%"
    
    const numberOfSteps = numberOfPages + 1;
    const currentStep = currentPage;
    const share = (currentStep / numberOfSteps) * 100;
    return `${Math.floor(+share)}%`;
  };

  return (
    <div className="page-control">
      <p>
        <b>{currentPage}</b> {translate('of')} {numberOfPages}
      </p>
      <div className="loading-bar">
        <div
          className="state"
          style={{ width: getCurrentBarPercentage() }}
        ></div>
      </div>
    </div>
  );
};

export default pageControl;
